var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTram4Backwheels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 86,
    viewBox: "0 0 375 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 331.895,
    cy: 43,
    r: 37.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.5,
    cy: 43,
    r: 37.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.8945,
    cy: 43,
    r: 37.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 43,
    r: 37.5,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram4Backwheels);
export default __webpack_public_path__ + "static/media/tram4-backwheels.0fa28d32c2f5af08c7fb789b48c4f2bc.svg";
export { ForwardRef as ReactComponent };